import { Box, Typography, Grid, useTheme } from '@mui/material';

interface SectorInfoProps {
  sector: any;
}

export function SectorInfo({ sector }: SectorInfoProps) {
  const theme = useTheme();

  return (
    <>
      <Box sx={{ mb: 4 }}>
        <Typography
          sx={{
            color: theme.palette.text.primary,
            fontWeight: 800,
            fontSize: 28,
            letterSpacing: -1,
          }}
        >
          {sector.name}
        </Typography>
        <Typography
          sx={{
            color: theme.palette.text.primary,
            fontSize: 16,
            fontWeight: 500,
          }}
        >
          Empresa: {sector.tenant?.fantasyName || sector.tenant?.name}
        </Typography>
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              background: theme.palette.background.default,
              borderRadius: 3,
              p: 3,
              height: '100%',
            }}
          >
            <Typography fontWeight={700} fontSize={17} color={theme.palette.text.primary} mb={2}>
              Dados do Setor
            </Typography>
            <Box component="dl" sx={{ m: 0 }}>
              <Box sx={{ display: 'flex', mb: 1, alignItems: 'center' }}>
                <dt
                  style={{
                    width: 120,
                    color: theme.palette.text.secondary,
                    fontWeight: 500,
                    textAlign: 'right',
                    margin: 0,
                    flexShrink: 0,
                    fontSize: 15,
                  }}
                >
                  Nome:
                </dt>
                <dd style={{ margin: 0, marginLeft: 16, fontWeight: 500, fontSize: 15 }}>
                  {sector.name}
                </dd>
              </Box>
              <Box sx={{ display: 'flex', mb: 1, alignItems: 'center' }}>
                <dt
                  style={{
                    width: 120,
                    color: theme.palette.text.secondary,
                    fontWeight: 500,
                    textAlign: 'right',
                    margin: 0,
                    flexShrink: 0,
                    fontSize: 15,
                  }}
                >
                  Descrição:
                </dt>
                <dd style={{ margin: 0, marginLeft: 16, fontWeight: 500, fontSize: 15 }}>
                  {sector.description || '-'}
                </dd>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              background: theme.palette.background.default,
              borderRadius: 3,
              p: 3,
              height: '100%',
            }}
          >
            <Typography fontWeight={700} fontSize={17} color={theme.palette.text.primary} mb={2}>
              Informações
            </Typography>
            <Box component="dl" sx={{ m: 0 }}>
              <Box sx={{ display: 'flex', mb: 1, alignItems: 'center' }}>
                <dt
                  style={{
                    width: 120,
                    color: theme.palette.text.secondary,
                    fontWeight: 500,
                    textAlign: 'right',
                    margin: 0,
                    flexShrink: 0,
                    fontSize: 15,
                  }}
                >
                  Empresa:
                </dt>
                <dd style={{ margin: 0, marginLeft: 16, fontWeight: 500, fontSize: 15 }}>
                  {sector.tenant?.fantasyName || sector.tenant?.name}
                </dd>
              </Box>
              <Box sx={{ display: 'flex', mb: 1, alignItems: 'center' }}>
                <dt
                  style={{
                    width: 120,
                    color: theme.palette.text.secondary,
                    fontWeight: 500,
                    textAlign: 'right',
                    margin: 0,
                    flexShrink: 0,
                    fontSize: 15,
                  }}
                >
                  Criado em:
                </dt>
                <dd style={{ margin: 0, marginLeft: 16, fontWeight: 500, fontSize: 15 }}>
                  {sector.createdAt ? new Date(sector.createdAt).toLocaleString() : '-'}
                </dd>
              </Box>
              <Box sx={{ display: 'flex', mb: 1, alignItems: 'center' }}>
                <dt
                  style={{
                    width: 120,
                    color: theme.palette.text.secondary,
                    fontWeight: 500,
                    textAlign: 'right',
                    margin: 0,
                    flexShrink: 0,
                    fontSize: 15,
                  }}
                >
                  Atualizado em:
                </dt>
                <dd style={{ margin: 0, marginLeft: 16, fontWeight: 500, fontSize: 15 }}>
                  {sector.updatedAt ? new Date(sector.updatedAt).toLocaleString() : '-'}
                </dd>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}